import {Mapper} from '@s-ui/domain'

export class FromRawCommentResponseToCommentEntityMapper extends Mapper {
  constructor({commentEntityFactory}) {
    super()

    this._commentEntityFactory = commentEntityFactory
  }

  map = rawResponse => {
    const {commentId, user, comment, creationDate, answers} = rawResponse

    return this._commentEntityFactory({
      id: commentId,
      author: {
        name: user.name,
        photoUrl: user.avatar
      },
      text: comment,
      date: creationDate,
      ...(answers && {answers})
    })
  }
}
